import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux";

// react alert
import { positions, Provider as ReactAlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
// Ends here

import configureStore from "./store";

import { unregister } from "./registerServiceWorker";

import App from "./components/App";

const preloadedState = window.__PRELOADED_STATE__ ? window.__PRELOADED_STATE__ : {};
delete window.__PRELOADED_STATE__;

// Create redux store
const store = configureStore(preloadedState);

// Get app's root element
const rootEl = document.getElementById("root");

// Determine if we should use hot module rendering or DOM hydration
const renderMethod = !!module.hot ? ReactDOM.render : ReactDOM.hydrate;

// React Alert Set up
const options = {
	timeout: 5000,
	position: positions.BOTTOM_CENTER
};

renderMethod(
	<Provider store={store}>
		<ReactAlertProvider template={AlertTemplate} {...options}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</ReactAlertProvider>
	</Provider>,
	rootEl
);

if (module.hot) {
	module.hot.accept("./components/App", () => {
		ReactDOM.hydrate(
			<Provider store={store}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</Provider>,
			rootEl
		);
	});
}

// registerServiceWorker()
unregister();



// WEBPACK FOOTER //
// ./src/index.js